import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {DWHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function EsameV() {
    const {theme} = useSingleTheme('tastewines');
    const tastewines_Theme = theme;
    const {articles} = useArticles('tastewines');
    const article = articles.slice(1, 2) || [];
    const articles_EV = article[0]; 
    const {paragraphs} = useParagraphs('tastewines_2');

    return (
        <section>
            {theme && <DWHeadLinks title={tastewines_Theme.tema_titolo} /> }
            <ThemesScreen theme={tastewines_Theme} article={articles_EV} paragraphs={paragraphs}/> 
        </section>
    )
}
export default EsameV;
